import { render, staticRenderFns } from "./BindingVip.vue?vue&type=template&id=a29027ee&scoped=true&"
import script from "./BindingVip.vue?vue&type=script&lang=js&"
export * from "./BindingVip.vue?vue&type=script&lang=js&"
import style0 from "./BindingVip.vue?vue&type=style&index=0&id=a29027ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29027ee",
  null
  
)

export default component.exports